import { render } from "./Profiling.vue?vue&type=template&id=b4fddfea&scoped=true"
import script from "./Profiling.vue?vue&type=script&lang=js"
export * from "./Profiling.vue?vue&type=script&lang=js"

import "./Profiling.vue?vue&type=style&index=0&id=b4fddfea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fddfea"]])

export default __exports__